export enum EResultsSortingMode {
  TIME = 'SORT_BY_TIME',
  SCORE = 'SORT_BY_SCORE',
  PRICE = 'SORT_BY_PRICE',
  DURATION = 'SORT_BY_DURATION',
  CARBON_FOOTPRINT = 'SORT_BY_CARBON_FOOTPRINT',
}
